import axios, { baseUrl } from './axios';

export default {
  loadOnlineServiceList: async (options = {}) => {
    const result = await axios.get(
      `${baseUrl}/customer/mob/specialties/online_services`,
    );
    return result.data;
  },
};
